import { SidenavMenu } from './sidenav-menu.model';

export const sidenavMenuItems = [
    new SidenavMenu(1, 'HOME', '/home', null, null, false, 0),
    new SidenavMenu(2, 'Products', '/products', null, null, false, 0),
    new SidenavMenu(3, 'Contacts', '/contact', null, null, false, 0),
]